(ns frontend.view.settings2.kyc.sub
  (:require
   [re-frame.core :as rf]
   [ui.state.session.sub :as session-sub]
   [frontend.view.settings2.kyc.model :as model]
   [common.schema.entities.workspace.kyc.automated-renewal.configuration :as c-config]))

(rf/reg-sub
 ::state
 (fn [db]
   (get-in db model/root-path)))

(rf/reg-sub
 ::saved-configuration
 :<- [::session-sub/tenant]
 (fn [tenant]
   ;; The email subjects + templates will be merged during runtime at backend, so we can treat this as effectively saved
   ;; Makes managing email subjects + templates easier in the code before we have template editor
   (some->> tenant
            :tenant/automated-kyc-renewal-configuration
            (c-config/merge-config-with-hard-coded-email-subject-and-template tenant))))

(rf/reg-sub
 ::default-configuration
 :<- [::session-sub/tenant]
 (fn [tenant]
   (c-config/get-tenant-default-configuration tenant)))

(rf/reg-sub
 ::default-reminder-config
 :<- [::default-configuration]
 (fn [configuration]
   (:reminder-config configuration)))

(rf/reg-sub
 ::saved-reminder-config
 :<- [::saved-configuration]
 (fn [config]
   (:reminder-config config)))

(rf/reg-sub
 ::configuration
 :<- [::state]
 (fn [state]
   (get state model/configuration-key)))

(rf/reg-sub
 ::reminder-config
 :<- [::configuration]
 (fn [config]
   (:reminder-config config)))

(rf/reg-sub
 ::reminder-config-changes?
 :<- [::saved-reminder-config]
 :<- [::default-reminder-config]
 :<- [::reminder-config]
 (fn [[saved-config
       default-config
       current-config]]
   (if (and (not saved-config)
            (= current-config default-config))
     false
     (not= saved-config current-config))))

(rf/reg-sub
 ::reminders-enabled?
 :<- [::reminder-config]
 (fn [reminder-config]
   (:enabled? reminder-config)))

(rf/reg-sub
 ::reminders
 :<- [::reminder-config]
 (fn [reminder-config]
   (:reminders reminder-config)))

(rf/reg-sub
 ::email-templates
 :<- [::state]
 (fn [state]
   (get state :email-templates)))

(rf/reg-sub
 ::reminder-email-preview-index
 :<- [::state]
 (fn [state]
   (get state :reminder-email-preview)))

(rf/reg-sub
 ::reminder-email-lang
 :<- [::state]
 (fn [state]
   (get state :reminder-email-lang :en)))

(rf/reg-sub
 ::reminder-remail-preview-email-config
 :<- [::reminders]
 :<- [::reminder-email-preview-index]
 (fn [[reminders index]]
   (when index
     (get reminders index))))

